import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('ca-ES', {
    style: 'currency',
    currency: 'EUR',
    useGrouping: true,
  }).format(value);
}

// Import/decimal amb 2 decimals arrodonits, coma decimal i punt de milers.
export function formatDecimal(value: number, decimals = 2): string {
  return new Intl.NumberFormat('ca-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  }).format(Number(value) || 0);
}

/**
 * Interpreta un import escrit o enganxat amb la convenció de l'ERP (punt = milers, coma = decimal)
 * i el retorna amb punt decimal ("1234.56") per a parseFloat / l'API, o '' si no hi ha cap xifra.
 *   "250.000" → "250000" · "250.000,50" → "250000.50" · "250000,5" → "250000.5"
 * Els punts s'ignoren (són separadors de milers). Tolera estats parcials mentre s'escriu ("250," → "250").
 */
export function parseMoneyInput(text: string): string {
  const s = (text ?? '').replace(/[^\d,.]/g, '').replace(/\./g, '');
  if (!/\d/.test(s)) return '';
  const i = s.indexOf(',');
  if (i < 0) return s;
  const intPart = s.slice(0, i) || '0';
  const decPart = s.slice(i + 1).replace(/,/g, '');
  return decPart ? `${intPart}.${decPart}` : intPart;
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat('ca-ES', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value / 100);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('ca-ES', { useGrouping: true }).format(value);
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('ca-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(date));
}
